export default {
	featureFlags: {
		REACT_APP_ENABLE_DRIVER_APP_MERGE: true,
		REACT_APP_ENABLE_LLP_18517_NON_BARCODE_DELIVERY: true,
		REACT_APP_ENABLE_DRIVER_APP_MERGE_PHASE2: true
	}
}
